import { useState, useCallback } from "react";
import AuthService from "../services/authentication.service";
import { UserRolesEnum } from "../../utils/enums";

const useRowSelection = (rowClickHandler = () => {}) => {
   const [selectedRowKeys, setSelectedRowKeys] = useState([]);

   const onSelectChange = useCallback((newSelectedRowKeys) => {
      setSelectedRowKeys(newSelectedRowKeys);
   }, []);

   const onRow = useCallback(
      (record) => {
         const isAuthorized = AuthService.isAuthorized([
            UserRolesEnum.SuperAdmin,
            UserRolesEnum.Organization,
            UserRolesEnum.AdminOfOrganization,
            UserRolesEnum.SeniorProjectManager,
            UserRolesEnum.ProjectManager
         ]);

         if (!isAuthorized) return {};

         return {
            onClick: (e) => {
               if (e.target.closest(".icon-group")) {
                  e.stopPropagation();
                  return;
               }

               const newSelectedRowKeys = [...selectedRowKeys];
               const keyIndex = newSelectedRowKeys.indexOf(record.key);

               if (keyIndex >= 0) {
                  newSelectedRowKeys.splice(keyIndex, 1);
               } else {
                  newSelectedRowKeys.push(record.key);
               }

               if (!e.target.closest(".ant-table-cell:last-child")) {
                  rowClickHandler(record);
               }

               onSelectChange(newSelectedRowKeys);
            }
         };
      },
      [selectedRowKeys, onSelectChange, rowClickHandler]
   );

   const rowSelection = {
      selectedRowKeys,
      onChange: onSelectChange
   };

   return { selectedRowKeys, setSelectedRowKeys, rowSelection, onRow };
};

export default useRowSelection;
